<template>
  <modal-search-select-input
    :id="id"
    :options="ddiOptions"
    :modelValue="filters.ddi_busca"
    :disabled="disabled"
    :errorMessage="errors.id_ddi"
    @onUpdateList="
      ($event) => {
        loadDDIList({ ddi_busca: $event });
      }
    "
    @onSelect="onSelectDDI($event)"
    @update:modelValue="
      (newValue) => {
        filters.ddi_busca = newValue;
      }
    "
  />
</template>
<script>
import ModalSearchSelectInput from "./ModalSearchSelectInput.vue";
import axios from "axios";

export default {
  name: "ModalCelularDdiInput",
  components: {
    ModalSearchSelectInput,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
    value: {
      required: false,
      type: String | Number,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  watch: {
    'filters.ddi_busca': function(newVal) {
      if (newVal === '') {
        this.filters.id_ddi = ''; // Limpa o ID interno
        this.$emit('update:modelValue', ''); // Notifica o componente pai para atualizar userDDI
      }
    },
    value: function(newVal) {
      if (newVal) {
        const rotulo = this.findByValue(newVal);
        this.filters.id_ddi = newVal;
        this.filters.ddi_busca = rotulo;
      }
    },
  },
  data() {
    return {
      ddiOptions: {},
      filters: {
        id_ddi: "",
        ddi_busca: "",
      },
      errors: {
        id_ddi: "",
      },
    };
  },
  mounted() {
    const filtrosbackend = {
      ddi_id: this.value,
    };

    this.loadDDIList(filtrosbackend).then(() => {
      // se value for passado, configura o componente com ele
      // o value é o ctel_id
      if (this.value) {
        const rotulo = this.findByValue(this.value);
        this.filters.id_ddi = this.value;
        this.filters.ddi_busca = rotulo;
      }
    });
  },
  methods: {
    getDdiId() {
      return this.filters.id_ddi;
    },
    findByValue(searchValue) {
      return (
        Object.keys(this.ddiOptions).find(
          (key) => this.ddiOptions[key].value == searchValue
        ) || null
      );
    },
    onSelectDDI(value) {
      this.filters.id_ddi = value;
      this.$emit("update:modelValue", value);
    },
    loadDDIList(filtrosbackend) {
      this.filters.id_ddi = "";

      const params = {
        ddi_busca: filtrosbackend.ddi_busca,
        ddi_id: filtrosbackend.ddi_id,
      };

      return axios
        .get(`${process.env.API_PBM}/ddi`, { params })
        .then((response) => {
          if (response.data) {
            const responseBody = response.data;
            this.ddiOptions;

            let newDdiOtions = {};
            responseBody.data.forEach((ddi_dados) => {
              const ddi_rotulo = `(+${ddi_dados.ctel_ddi}) ${ddi_dados.ctel_pais}`;
              newDdiOtions[ddi_rotulo] = {
                value: ddi_dados.ctel_id,
              };
            });

            this.ddiOptions = newDdiOtions;
          }
        });
    },
  },
};
</script>
<style scoped>
label {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #666;
  font-weight: bold;
  margin-bottom: 5px;
}

table td,
table th {
  font-size: 12px;
}

.div-block {
  display: block;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ModalCelularDdiInput.vue